import React from 'react';

const EmptyCloudIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries-large">
      <div className="vbz-icon-beneficiaries-large-empty-cloud" />
    </div>
  );
};

export default EmptyCloudIcon;
